var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTruck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.87 3.61914H3.13C2.23 3.61914 1.5 4.34914 1.5 5.24914V13.4891C1.5 14.2191 1.98 14.8291 2.64 15.0391C1.95 15.5891 1.5 16.4291 1.5 17.3691C1.5 19.0291 2.84 20.3691 4.5 20.3691C5.4 20.3691 6.2 19.9591 6.75 19.3391C7.3 19.9691 8.1 20.3691 9 20.3691C10.57 20.3691 11.85 19.1591 11.97 17.6191H18.58V20.3691H20.08V17.6191H21.31C21.97 17.6191 22.5 17.1191 22.5 16.4991V5.24914C22.5 4.34914 21.77 3.61914 20.87 3.61914ZM4.5 18.8791C3.67 18.8791 3 18.2091 3 17.3791C3 16.5491 3.67 15.8791 4.5 15.8791C5.33 15.8791 6 16.5491 6 17.3791C6 18.2091 5.33 18.8791 4.5 18.8791ZM9 18.8791C8.17 18.8791 7.5 18.2091 7.5 17.3791C7.5 16.5491 8.17 15.8791 9 15.8791C9.83 15.8791 10.5 16.5491 10.5 17.3791C10.5 18.2091 9.83 18.8791 9 18.8791ZM21 16.1191H11.72C11.54 15.7291 11.28 15.3991 10.97 15.1191H21V16.1191ZM10.68 13.6191H3.13C3.06 13.6191 3 13.5591 3 13.4891V5.24914C3 5.17914 3.06 5.11914 3.13 5.11914H20.87C20.94 5.11914 21 5.17914 21 5.24914V13.6191H10.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTruck);
export default __webpack_public_path__ + "static/media/ic-truck.7ede8ddc37110a0e5c8603c8c91af3cd.svg";
export { ForwardRef as ReactComponent };